<template>
    <span>{{ time | prettify }}</span>
</template>

<script>
export default {
    props: ['time'],
	filters: {
        prettify : function(value) {
            if(!value) return;
            
            let data = value.split(':'),
                hours = data[0],
                minutes = data[1],
                secondes = data[2]

            if (hours < 10) hours = '0'+hours
            if (minutes < 10) minutes = '0'+minutes
            if (secondes < 10) secondes = '0'+secondes

            return `${hours}:${minutes}:${secondes}`
        }
	}
}
</script>